<div class="user-view-container">

  @if (loading) {
    <div class="loading-overlay">
      <mat-spinner diameter="60"></mat-spinner>
      <p>Loading user...</p>
    </div>
  }

  @if (error) {
    <mat-card class="error-card">
      <mat-card-content>
        <mat-icon color="warn">error</mat-icon>
        <h2>{{ error }}</h2>
        <button mat-raised-button color="primary" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Return to Users
        </button>
      </mat-card-content>
    </mat-card>
  }

  @if (!loading && !error && currentUser) {

    <mat-sidenav-container class="sidenav-container">

      <!-- Actions Sidenav (Left Side) -->
      <mat-sidenav mode="side" opened position="start" class="actions-sidenav">
        <app-entity-actions-sidenav
          title="User Actions"
          [actions]="sidenavActions"
          [tabs]="sidenavTabs"
          [selectedTabIndex]="selectedTabIndex"
          (tabSelected)="selectTab($event)">
        </app-entity-actions-sidenav>
      </mat-sidenav>

      <!-- Main Content -->
      <mat-sidenav-content class="form-content">

        <!-- Header Actions Bar -->
        <div class="header-bar">
          <button mat-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
            Back to Users
          </button>

          <div class="header-actions">
            <button mat-raised-button color="primary" (click)="editUser()">
              <mat-icon>edit</mat-icon>
              Edit User
            </button>
          </div>
        </div>

        <!-- Static Information Section (Always Visible) -->
        <div class="static-info-section">
          <!-- User Name Header -->
          <div class="user-name-header">
            <h1>{{ currentUser.userFullName || currentUser.fullName || 'N/A' }}</h1>
            <div class="user-metadata">
              <span class="user-num">User ID: {{ currentUser.userNum || currentUser.userId || '' }}</span>
            </div>
          </div>

          <!-- Essential Information -->
          <div class="info-section">
            <div class="section-header">
              <mat-icon>person</mat-icon>
              <h3>Essential Information</h3>
            </div>
            <div class="info-grid essential-grid">
              <div class="info-field">
                <label>First Name</label>
                <div class="value">{{ currentUser.firstName || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Middle Name</label>
                <div class="value">{{ currentUser.middleName || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Last Name</label>
                <div class="value">{{ currentUser.lastName || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Suffix</label>
                <div class="value">{{ currentUser.suffix || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Email</label>
                <div class="value">{{ currentUser.email || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Role</label>
                <div class="value">{{ currentUser.role || 'N/A' }}</div>
              </div>

              <div class="info-field full-width">
                <label>Departments</label>
                <div class="value">{{ departmentsDisplay }}</div>
              </div>

              <div class="info-field full-width">
                <label>Sites</label>
                <div class="value">{{ sitesDisplay }}</div>
              </div>

              <div class="info-field">
                <label>Friendly Name</label>
                <div class="value">{{ currentUser.friendlyName || 'N/A' }}</div>
              </div>
            </div>
          </div>

          <!-- Contact Information -->
          <div class="info-section">
            <div class="section-header">
              <mat-icon>contact_phone</mat-icon>
              <h3>Contact Information</h3>
            </div>
            <div class="info-grid contact-grid">
              <div class="info-field">
                <label>Office Phone</label>
                <div class="value">{{ currentUser.officePhone || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Mobile Phone</label>
                <div class="value">{{ currentUser.mobilePhone || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Fax Phone</label>
                <div class="value">{{ currentUser.faxPhone || 'N/A' }}</div>
              </div>

              <div class="info-field full-width">
                <label>All Phones</label>
                <div class="value">{{ phonesDisplay }}</div>
              </div>
            </div>
          </div>

          <!-- System Information -->
          <div class="info-section">
            <div class="section-header">
              <mat-icon>settings</mat-icon>
              <h3>System Information</h3>
            </div>
            <div class="info-grid system-grid">
              <div class="info-field">
                <label>Date Added</label>
                <div class="value">{{ currentUser.dateAdded || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Last Login</label>
                <div class="value">{{ currentUser.lastLogin || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Last Login IP</label>
                <div class="value">{{ currentUser.lastLoginIp || 'N/A' }}</div>
              </div>

              <div class="info-field">
                <label>Login Count</label>
                <div class="value">{{ currentUser.loginCount || 0 }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabbed Content -->
        <mat-tab-group
          [selectedIndex]="selectedTabIndex"
          (selectedIndexChange)="selectTab($event)"
          class="user-tabs">

          <!-- Tab 0: Details -->
          <mat-tab label="Details">
            <div class="tab-content">
              <mat-card class="info-card">
                <mat-card-header>
                  <mat-card-title>
                    <mat-icon>info</mat-icon>
                    Additional User Information
                  </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  <div class="info-grid additional-grid">
                    <div class="info-field full-width">
                      <label>Other Information</label>
                      <div class="value">{{ currentUser.other || 'N/A' }}</div>
                    </div>

                    <div class="info-field">
                      <label>Contracting Entity Permission</label>
                      <div class="value">{{ currentUser.contractingEntityPermission || 'N/A' }}</div>
                    </div>

                    <div class="info-field">
                      <label>Organization Permission</label>
                      <div class="value">{{ currentUser.orgPermission || 'N/A' }}</div>
                    </div>

                    <div class="info-field full-width">
                      <label>Contract Type Permissions</label>
                      <div class="value">
                        @if (currentUser.contractTypePermission && currentUser.contractTypePermission.length > 0) {
                          {{ currentUser.contractTypePermission.join(', ') }}
                        } @else {
                          N/A
                        }
                      </div>
                    </div>

                    <div class="info-field full-width">
                      <label>Department Permissions</label>
                      <div class="value">
                        @if (currentUser.departmentPermission && currentUser.departmentPermission.length > 0) {
                          {{ currentUser.departmentPermission.join(', ') }}
                        } @else {
                          N/A
                        }
                      </div>
                    </div>

                    <div class="info-field full-width">
                      <label>Site Permissions</label>
                      <div class="value">
                        @if (currentUser.sitePermission && currentUser.sitePermission.length > 0) {
                          {{ currentUser.sitePermission.join(', ') }}
                        } @else {
                          N/A
                        }
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>

          <!-- COMMENTED OUT - May bring back someday -->
          <!-- Tab 1: Contracts -->
          <!--
          <mat-tab label="Contracts">
            <div class="tab-content">
              @if (currentUser.contracts && currentUser.contracts.length > 0) {
                <mat-card class="info-card">
                  <mat-card-content>
                    <p>Contracts: {{ currentUser.contracts.length }}</p>
                  </mat-card-content>
                </mat-card>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>description</mat-icon>
                    <p>No contracts associated with this user</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>
          -->

          <!-- Tab 2: BAAs -->
          <!--
          <mat-tab label="BAAs">
            <div class="tab-content">
              @if (currentUser.baas && currentUser.baas.length > 0) {
                <app-baa-connections
                  [selectedBaaList]="currentUser.baas">
                </app-baa-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>policy</mat-icon>
                    <p>No Business Associate Agreements associated with this user</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>
          -->

          <!-- Tab 3: COIs -->
          <!--
          <mat-tab label="COIs">
            <div class="tab-content">
              @if (currentUser.cois && currentUser.cois.length > 0) {
                <app-coi-connections
                  [selectedCoiList]="currentUser.cois">
                </app-coi-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>verified_user</mat-icon>
                    <p>No Certificates of Insurance associated with this user</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>
          -->

          <!-- Tab 4: Vendors -->
          <!--
          <mat-tab label="Vendors">
            <div class="tab-content">
              @if (currentUser.vendors && currentUser.vendors.length > 0) {
                <app-vendor-connections
                  [selectedVendorList]="currentUser.vendors">
                </app-vendor-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>business</mat-icon>
                    <p>No vendors associated with this user</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>
          -->

          <!-- Tab 5: Parties -->
          <!--
          <mat-tab label="Parties">
            <div class="tab-content">
              <mat-card class="empty-state">
                <mat-card-content>
                  <mat-icon>groups</mat-icon>
                  <p>Parties content coming soon</p>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>
          -->

          <!-- Tab 6: People -->
          <!--
          <mat-tab label="People">
            <div class="tab-content">
              @if (currentUser.people && currentUser.people.length > 0) {
                <mat-card class="info-card">
                  <mat-card-content>
                    <p>Related People: {{ currentUser.people.length }}</p>
                  </mat-card-content>
                </mat-card>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>person</mat-icon>
                    <p>No related people for this user</p>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>
          -->

          <!-- Tab 1: Attachments (renumbered from Tab 7) -->
          <mat-tab label="Attachments">
            <div class="tab-content">
              @if (entityAttachments && entityAttachments.length > 0) {
                <app-attachment-connections
                  [attachmentObjectArray]="entityAttachments"
                  (attachmentUpdated)="refreshAttachments()">
                </app-attachment-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>attach_file</mat-icon>
                    <p>No attachments for this user</p>
                    <button mat-raised-button color="primary" (click)="addAttachment()">
                      <mat-icon>add</mat-icon>
                      Add Attachment
                    </button>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 2: Important Dates (renumbered from Tab 8) -->
          <mat-tab label="Important Dates">
            <div class="tab-content">
              @if (entityDates && entityDates.length > 0) {
                <app-critical-date-connections
                  [dateObjectArray]="entityDates"
                  (criticalDateUpdated)="refreshCriticalDates()">
                </app-critical-date-connections>
              } @else {
                <mat-card class="empty-state">
                  <mat-card-content>
                    <mat-icon>event</mat-icon>
                    <p>No important dates for this user</p>
                    <button mat-raised-button color="primary" (click)="addCriticalDate()">
                      <mat-icon>add</mat-icon>
                      Add Important Date
                    </button>
                  </mat-card-content>
                </mat-card>
              }
            </div>
          </mat-tab>

          <!-- Tab 9: Notes -->
          <!--
          <mat-tab label="Notes">
            <div class="tab-content">
              <mat-card class="empty-state">
                <mat-card-content>
                  <mat-icon>note</mat-icon>
                  <p>Notes content coming soon</p>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>
          -->

          <!-- Tab 10: Risk Assessments -->
          <!--
          <mat-tab label="Risk Assessments">
            <div class="tab-content">
              <mat-card class="empty-state">
                <mat-card-content>
                  <mat-icon>assessment</mat-icon>
                  <p>Risk Assessments content coming soon</p>
                </mat-card-content>
              </mat-card>
            </div>
          </mat-tab>
          -->

        </mat-tab-group>

      </mat-sidenav-content>

    </mat-sidenav-container>

  }

</div>
